export const UNAUTHORIZED_MESSAGE =
  'Not Authorized - some permissions are missing. Please contact your administrator.';

enum RoleTypes {
  BASIC = 'RoboticsPlatform_basic',
  ADMIN = 'RoboticsPlatform_admin',
}

export enum Permission {
  VIEW = 'view',
  CONTROL = 'control',
  MISSION_EXECUTION = 'mission_execution',
  ARM_CONTROL = 'arm_control',
}

export type RawPermission = `${string}:${number}:${Permission}`;

export default RoleTypes;
